const disablingSiblings = [
  'content-section',
  'page-footer',
  'footer-contact',
];

const ignoringSiblings = [
  'floating-contact',
];

/**
 * @param {HTMLElement} element
 */
function getNextSibling(element) {
  const nextSibling = element.nextElementSibling;
  const classes = nextSibling.classList;

  if (ignoringSiblings.some(x => classes.contains(x))) {
    return getNextSibling(nextSibling);
  }

  return nextSibling;
}

function init() {
  /**
   * @type {HTMLElement[]}
   */
  const elements = [...document.getElementsByClassName('content-section--push-down-nonsection')];

  for (const element of elements) {
    const nextSibling = getNextSibling(element);
    if (nextSibling == null || disablingSiblings.some(x => nextSibling.classList.contains(x)) === false) {
      continue;
    }

    element.classList.remove('content-section--push-down');
  }
}

export default {
  init
}
